import { API_CONSULT } from 'Constants/client-modules';
import { WEBCHAT } from 'Constants/normalize-module';
import { conversation, conversations } from 'Schemas/schemas';

import * as ACTION_TYPES from './types';

export function doctorConversationsPending({ doctorId }) {
  return {
    types: [
      ACTION_TYPES.DOCTOR_CONVERSATIONS_PENDING_REQUESTED,
      ACTION_TYPES.DOCTOR_CONVERSATIONS_PENDING_SUCCEED,
      ACTION_TYPES.DOCTOR_CONVERSATIONS_PENDING_FAILED,
    ],
    promise: client => client.get(`/doctors/${doctorId}/pending-consults/stats`),
    options: {
      clientName: API_CONSULT,
    },
  };
}
export function conversationsRetrieve({ doctorId, params = {}, isReplace = false }) {
  return {
    types: [
      ACTION_TYPES.CONVERSATIONS_RETRIEVE_REQUESTED,
      ACTION_TYPES.CONVERSATIONS_RETRIEVE_SUCCEED,
      ACTION_TYPES.CONVERSATIONS_RETRIEVE_FAILED,
    ],
    promise: client =>
      client.get(`/doctors/${doctorId}/conversations`, {
        params,
      }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: conversations,
      },
      module: WEBCHAT,
      isReplace,
      clinicId: params.clinicId,
    },
  };
}

export function clearListConsultGroup() {
  return {
    type: ACTION_TYPES.CONVERSATIONS_CLEAR,
  };
}

export function conversationRetrieve(conversationId, params = {}) {
  return {
    types: [
      ACTION_TYPES.CONVERSATION_RETRIEVE_REQUESTED,
      ACTION_TYPES.CONVERSATION_RETRIEVE_SUCCEED,
      ACTION_TYPES.CONVERSATION_RETRIEVE_FAILED,
    ],
    promise: client => client.get(`/conversations/${conversationId}`, { params }),
    options: {
      clientName: API_CONSULT,
    },
    meta: {
      schema: {
        data: conversation,
      },
      module: WEBCHAT,
    },
  };
}

export function removeConversation(conversationId, clinicId) {
  return {
    type: ACTION_TYPES.CONVERSATION_REMOVE_BY_ID,
    payload: {
      conversationId,
      clinicId,
    },
  };
}

export function conversationEntities(conversationData) {
  return {
    type: ACTION_TYPES.CONVERSATIONS_ENTITIES_UPDATE,
    payload: {
      conversation: conversationData,
    },
    meta: {
      schema: {
        conversation,
      },
      module: WEBCHAT,
    },
  };
}

export function addConversation(conversationId, clinicId) {
  return {
    type: ACTION_TYPES.CONVERSATION_ADD_BY_ID,
    payload: {
      conversationId,
      clinicId,
    },
  };
}
